<div>
    <p style="margin: 0; text-align: center;">A new update is available. Click <span style="text-decoration: underline; cursor: pointer;" (click)="reloadPage();">here</span> to refresh.</p>
</div>